var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { _areArrayEqual } from '../../utils';
import { _AdvancedEncryption128Cipher, _AdvancedEncryption256Cipher } from './advance-cipher';
import { _Sha256 } from './secureHash-algorithm256';
import { _Sha512 } from './secureHash-algorithm512';
var _EncryptionKey = /** @class */ (function () {
    function _EncryptionKey() {
    }
    Object.defineProperty(_EncryptionKey.prototype, "_sha256", {
        get: function () {
            if (typeof this._sha256Obj === 'undefined' || this._sha256Obj === null) {
                this._sha256Obj = new _Sha256();
            }
            return this._sha256Obj;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(_EncryptionKey.prototype, "_sha512", {
        get: function () {
            if (typeof this._sha512Obj === 'undefined' || this._sha512Obj === null) {
                this._sha512Obj = new _Sha512();
            }
            return this._sha512Obj;
        },
        enumerable: true,
        configurable: true
    });
    return _EncryptionKey;
}());
export { _EncryptionKey };
// PDF17 encryption support
var _BasicEncryption = /** @class */ (function (_super) {
    __extends(_BasicEncryption, _super);
    function _BasicEncryption() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    _BasicEncryption.prototype._checkOwnerPassword = function (password, ownerValidationSalt, userBytes, ownerPassword) {
        var hashData = new Uint8Array(password.length + 56);
        hashData.set(password, 0);
        hashData.set(ownerValidationSalt, password.length);
        hashData.set(userBytes, password.length + ownerValidationSalt.length);
        var result = this._sha256._hash(hashData, 0, hashData.length);
        return _areArrayEqual(result, ownerPassword);
    };
    _BasicEncryption.prototype._checkUserPassword = function (password, userValidationSalt, userPassword) {
        var hashData = new Uint8Array(password.length + 8);
        hashData.set(password, 0);
        hashData.set(userValidationSalt, password.length);
        var result = this._sha256._hash(hashData, 0, hashData.length);
        return _areArrayEqual(result, userPassword);
    };
    _BasicEncryption.prototype._getOwnerKey = function (password, ownerKeySalt, userBytes, ownerEncryption) {
        var hashData = new Uint8Array(password.length + 56);
        hashData.set(password, 0);
        hashData.set(ownerKeySalt, password.length);
        hashData.set(userBytes, password.length + ownerKeySalt.length);
        var key = this._sha256._hash(hashData, 0, hashData.length);
        return (new _AdvancedEncryption256Cipher(key))._decryptBlock(ownerEncryption, false, new Uint8Array(16));
    };
    _BasicEncryption.prototype._getUserKey = function (password, userKeySalt, userEncryption) {
        var hashData = new Uint8Array(password.length + 8);
        hashData.set(password, 0);
        hashData.set(userKeySalt, password.length);
        var key = this._sha256._hash(hashData, 0, hashData.length);
        return (new _AdvancedEncryption256Cipher(key))._decryptBlock(userEncryption, false, new Uint8Array(16));
    };
    return _BasicEncryption;
}(_EncryptionKey));
export { _BasicEncryption };
// PDF20 encryption support
var _AdvancedEncryption = /** @class */ (function (_super) {
    __extends(_AdvancedEncryption, _super);
    function _AdvancedEncryption() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    _AdvancedEncryption.prototype._checkOwnerPassword = function (password, ownerValidationSalt, userBytes, ownerPassword) {
        var hashData = new Uint8Array(password.length + 56);
        hashData.set(password, 0);
        hashData.set(ownerValidationSalt, password.length);
        hashData.set(userBytes, password.length + ownerValidationSalt.length);
        var result = this._hash(password, hashData, userBytes);
        return _areArrayEqual(result, ownerPassword);
    };
    _AdvancedEncryption.prototype._checkUserPassword = function (password, userValidationSalt, userPassword) {
        var hashData = new Uint8Array(password.length + 8);
        hashData.set(password, 0);
        hashData.set(userValidationSalt, password.length);
        var result = this._hash(password, hashData, new Uint8Array([]));
        return _areArrayEqual(result, userPassword);
    };
    _AdvancedEncryption.prototype._getOwnerKey = function (password, ownerKeySalt, userBytes, ownerEncryption) {
        var hashData = new Uint8Array(password.length + 56);
        hashData.set(password, 0);
        hashData.set(ownerKeySalt, password.length);
        hashData.set(userBytes, password.length + ownerKeySalt.length);
        var key = this._hash(password, hashData, userBytes);
        return (new _AdvancedEncryption256Cipher(key))._decryptBlock(ownerEncryption, false, new Uint8Array(16));
    };
    _AdvancedEncryption.prototype._getUserKey = function (password, userKeySalt, userEncryption) {
        var hashData = new Uint8Array(password.length + 8);
        hashData.set(password, 0);
        hashData.set(userKeySalt, password.length);
        var key = this._hash(password, hashData, new Uint8Array([]));
        var cipher = new _AdvancedEncryption256Cipher(key);
        return cipher._decryptBlock(userEncryption, false, new Uint8Array(16));
    };
    _AdvancedEncryption.prototype._hash = function (password, input, userBytes) {
        var data = this._sha256._hash(input, 0, input.length).subarray(0, 32);
        var encrypted = new Uint8Array([0]);
        var i = 0;
        while (i < 64 || encrypted[encrypted.length - 1] > i - 32) {
            var combinedLength = password.length + data.length + userBytes.length;
            var combinedArray = new Uint8Array(combinedLength);
            var writeOffset = 0;
            combinedArray.set(password, writeOffset);
            writeOffset += password.length;
            combinedArray.set(data, writeOffset);
            writeOffset += data.length;
            combinedArray.set(userBytes, writeOffset);
            var k1 = new Uint8Array(combinedLength * 64);
            for (var j = 0, pos = 0; j < 64; j++) {
                k1.set(combinedArray, pos);
                pos += combinedLength;
            }
            var cipher = new _AdvancedEncryption128Cipher(data.subarray(0, 16));
            encrypted = cipher._encrypt(k1, data.subarray(16, 32));
            var remainder = 0;
            for (var z = 0; z < 16; z++) {
                remainder *= 256 % 3;
                remainder %= 3;
                remainder += (encrypted[z] >>> 0) % 3;
                remainder %= 3;
            }
            if (remainder === 2) {
                data = this._sha512._hash(encrypted, 0, encrypted.length);
            }
            else if (remainder === 1) {
                data = this._sha512._hash(encrypted, 0, encrypted.length, true);
            }
            else if (remainder === 0) {
                data = this._sha256._hash(encrypted, 0, encrypted.length);
            }
            i++;
        }
        return data.subarray(0, 32);
    };
    return _AdvancedEncryption;
}(_EncryptionKey));
export { _AdvancedEncryption };
